<template>
  <div
    v-if="expiredDate"
    class="main-menu menu-fixed menu-accordion menu-shadow bg-primarySpore"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div :class="isMouseHovered || !isVerticalMenuCollapsed ? 'navbar-header expanded mb-5' : 'navbar-header expanded mb-3'">
      <slot name="header" :toggleVerticalMenuActive="toggleVerticalMenuActive" :toggleCollapsed="toggleCollapsed" :collapseTogglerIcon="collapseTogglerIcon" >
        <b-link class="d-inline-block" to="/">
          <span :class="isMouseHovered || !isVerticalMenuCollapsed ? 'd-flex align-items-center pl-2 mt-1  d-inline-block' : 'd-flex align-items-center mt-1 d-inline-block'">
            <b-img
              :src="isMouseHovered || !isVerticalMenuCollapsed ? appLogoImage : appLogoCircle"
              alt="logo"
              :style="isMouseHovered || !isVerticalMenuCollapsed ? 'width: 100%' : 'width: 30%; margin-left: -12px;'"
            />
            <b-link v-if="isMouseHovered || !isVerticalMenuCollapsed" class="nav-link modern-nav-toggle d-inline-block mb-5 pb-5">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none text-white"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon text-white"
                @click="toggleCollapsed"
              />
            </b-link>
          </span>
        </b-link>
      </slot>
    </div>
    <div class="text-center mt-5">
      <b-avatar href="/profile" size="70px" class="shadow mt-2" :src="avatar || null"/>
    </div>
    <div class="text-center">
      <b-link href="/profile" class="text-white font-weight-bold">{{$store.state.session.AppActiveUser().displayName && $store.state.session.AppActiveUser().displayName.substring(0,15)}}</b-link>
    </div>
    <div class="text-center">
        <i18n textColor="text-white" :isShow="!isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered)" style="display:none;"/>
    </div>
    <div class="text-center">
      <select v-model="selectedDivision">
        <option v-for="division in listDivisions" :key="division.value" :value="division.value">{{division.label}}</option>
      </select>
    </div>
    <div class="text-center mb-1">
      <b-button class="text-white font-weight-bold" variant="link" size="sm" @click="logout">
        <feather-icon
          icon="LogOutIcon"
          size="20"
        />
        Salir de sesión
      </b-button>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main bg-primarySpore text-white"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg, BButton, BAvatar } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import i18n from '@core/spore-components/i18n/i18n'
import { empty } from '@/libs/tools/helpers'
import request from '@/libs/request/index'
import { logout } from '@/libs/session'
// import { setSessionStorage, getSessionStorage } from '@/libs/session/index'
export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    BButton,
    i18n,
    BAvatar
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true
    }
  },
  setup (props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)
    const selectedDivision = ref()
    const listDivisions = ref([])

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage, appLogoCircle } = $themeConfig.app

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,
      selectedDivision,
      listDivisions,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      appLogoCircle,
      avatar: '',
      expiredDate: false
    }
  },
  methods: {
    logout () {
      logout()
    },
    async getProfile () {
      const params = {
        url: 'users/avatar/load',
        method: 'GET'
      }
      await request(params).then(data => {
        if (!empty(data.data.data.avatar)) {
          this.avatar = 'data:image/jpeg;base64,' + data.data.data.avatar
          localStorage.setItem('avatar', 'data:image/jpeg;base64,' + data.data.data.avatar)
        }
      })
    },
    getDivisionUuid () {
      return this.$store.state.session.AppActiveUser().division?.uuid
    },
    getDivision () {
      const divisionList = this.$store.state.session.AppActiveUser().divisionList
      this.selectedDivision = this.getDivisionUuid()
      this.listDivisions = divisionList
    }
  },
  created () {
    if ((this.$store.state.session.AppActiveUser().expirationDate) !== undefined) {
      this.expiredDate = true

      if (empty(localStorage.getItem('avatar'))) {
        this.getProfile()
      } else {
        this.avatar = localStorage.getItem('avatar')
      }
      this.getDivision()
    }
  },
  watch: {
    selectedDivision (val) {
      if (val !== this.getDivisionUuid()) {
        this.$store.commit('session/UPDATE_USER_INFO', {
          division: { uuid: val }
        })
        // Reload page to update division. This is temporary. Change this to update division without reload page
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
